import { Modal } from '@enterprise-ui/canvas-ui-react'
import {
  getCurrentUTCDateString,
  getCurrentLocalDateString,
} from '../globalConfig/constants'

export const StartDateTimezoneMismatchExplanationModal = (props) => {
  return (
    <Modal headingText="Timezone Mismatch" {...props}>
      {new Date(getCurrentLocalDateString()) <
      new Date(getCurrentUTCDateString()) ? (
        <p>{`Dates are set in GMT. You are currently unable to select ${getCurrentLocalDateString()} because it is now ${getCurrentUTCDateString()} in GMT.`}</p>
      ) : (
        <p>{`Dates are set in GMT. ${getCurrentUTCDateString()} is currently the earliest start date you can set even though it is ${getCurrentLocalDateString()} in your local timezone.  Select ${getCurrentUTCDateString()} if you want the cost change to be effective immediately.`}</p>
      )}
    </Modal>
  )
}
